"use client";

import React from "react";
import { AwardTrustMarker } from "@interfaces/trust-markers.types";
import AckoDriveAwards from "./index";

export interface AckoDriveAwardsClientProps {
  awards: AwardTrustMarker[];
  className?: string;
}

const AckoDriveAwardsClient: React.FC<AckoDriveAwardsClientProps> = ({
  awards,
  className = "",
}) => {
  return (
    <AckoDriveAwards
      awards={awards}
      className={className}
      showViewAll={true}
    />
  );
};

export default AckoDriveAwardsClient;

